// extracted by mini-css-extract-plugin
module.exports = {"dialogPaper":"OnboardingTourDialog_dialogPaper__FZ2nH","content":"OnboardingTourDialog_content__wpeNl"};